<template lang="pug">
	.insertion-editor--context-menu
		ContextMenu(ref="menu", :items="editorContextMenuItems", @item-click="onItemClick", :target="target || '.jodit-workplace'", cssClass="insertion-editor--context-menu")
			template(v-slot:category="{ data }")
				.category.navigation-item(:style="{ '--imageUrl': `url('${data.imageUrl}')` }", :title="data.text")
					.item.flex-row.align-center.center.justify.space-medium
						.flex-row.flex-1.space.align-center
							.image-holder.flex-row.align-center.center
								.image(v-if="data.imageUrl")
								fas(v-if="data.icon", :icon="data.icon")
							.limit-width.text-overflow {{data.text}}
						fas(icon="angle-right", size="xs")
			template(v-slot:service="{ data }")
				.service.navigation-item(:style="{ '--imageUrl': `url('${data.imageUrl}')` }", :title="data.text")
					.item.flex-row.align-center.center.justify.space-medium
						.flex-row.flex-1.space.align-center
							.image-holder.flex-row.align-center.center
								.image(v-if="data.imageUrl")
								fas(v-if="data.icon", :icon="data.icon")
							.fixed-width.wrap {{data.text}}
						fas(icon="angle-right", size="xs")
			template(v-slot:output="{ data }")
				.output(:title="data.text")
					.flex-row.justify.align-center.space.align-center
						fas(icon="caret-right", size="xs")
						.flex-1
							.fixed-width.wrap {{data.text}}
			template(v-slot:loader)
				.output
					Loader(:text="$tCaption('Loading', '@actions') + '..'")
			template(v-slot:noData)
				.output {{$tCaption('No data')}}
			template(v-slot:header="{ data }")
				.output
					.font-small.upper.grey {{data.text}}
		UsedServicesContextMenu(:servicesTextSource="insertionDetails.ssml", :serviceIds="predefinedServicesIds", :templateFields="insertionDetails.templateFields", :hideUI="true", @menu-items-change="onUsedServicesItemsChange", :forceTemplateFields="forceTemplateFields")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import ContextMenu from 'app-core/ContextMenu.vue';
	import UsedServicesContextMenu from './UsedServicesContextMenu.vue';
	import json5 from 'json5';

	export default {
		translationCategory: 'insertion.EditorContextMenu',
		name: 'insertion-editor--context-menu',
		components: { Loader, ContextMenu, UsedServicesContextMenu },
		props: ['insertionDetails', 'target', 'predefinedUsedServices', 'preventContextMenuCustomProcess', 'customContextMenuItems', 'forceTemplateFields'],
		data() {
			return {
				webServicesMenuItems: [],
				isLoading: false,
				usedServicesMenuItems: [],
				templateFieldsMenuItems: []
			};
		},
		computed: {
			predefinedServicesIds() {
				return this.predefinedUsedServices?.length && this.predefinedUsedServices.map(f => f.Oid);
			},
			combinedMenuItems() {
				const allowedCustomMenuItems = (this.customContextMenuItems || []).filter(f => f.items?.some(item => item?.insertValue || item?.contextMenuVisible));
				return [
					...allowedCustomMenuItems.map(f => ({
						...f,
						items: f.items?.filter(item => item.insertValue || item?.contextMenuVisible) || [],
						template: 'category'
					})),
					...this.templateFieldsMenuItems.map(f => ({
						...f,
						template: 'category'
					})),
					...(this.usedServicesMenuItems.length ? [{
						text: this.$tCaption('Used services'),
						template: 'category',
						imageUrl: require('assets/usedservices.png'),
						items: this.usedServicesMenuItems
					}] : []),
					...this.webServicesMenuItems,
				]
			},
			editorContextMenuItems() {
				return this.isLoading ? [{ template: 'loader' }] : (this.combinedMenuItems.length ? this.combinedMenuItems : [{ template: 'noData' }]);
			}
		},
		watch: {
			combinedMenuItems: {
				handler(v) {
					this.$emit('used-services-change', [
						...(this.customContextMenuItems || []),
						...this.templateFieldsMenuItems,
						...this.usedServicesMenuItems,
					]);
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.editorContextMenu = this;
			this.isLoading = true;
			this.buildMenu().finally(() => this.isLoading = false);
		},
		methods: {
			onUsedServicesItemsChange(v) {
				this.usedServicesMenuItems = v.services || [];
				this.templateFieldsMenuItems = v.templateFields || [];
			},
			show() {
				if (this.$refs.menu)
					this.$refs.menu.show();
			},
			onItemClick(e) {
				let { param, service, insertValue } = e?.itemData;

				if (__DEBUG__)
					console.debug('On item click', { insertValue, param, service, itemData: e?.itemData });

				if (insertValue && !param?.IsArray) {
					if (param?.SsmlTemplate?.ssml && !this.preventContextMenuCustomProcess) {
						const div = document.createElement('div');
						const html = param.SsmlTemplate.ssml.replace(/\[VALUE\]/gi, insertValue);
						div.innerHTML = html;
						const rootElem = div.querySelector('voice') || div;
						insertValue = rootElem.innerHTML;
					}
					this.insertionDetails.editor().selection.insertHTML(insertValue);
				} else {
					if (e?.itemData?.action) {
						e.itemData.action(e.itemData);
					} else {
						if (param) {
							this.showWebServiceEditor(service, param);
						}
					}
				}
			},
			showWebServiceEditor(service, param) {
				const dataButton = this.insertionDetails.getTagButtons().find(f => f.name === 'data');
				if (dataButton) {
					if (__DEBUG__)
						console.debug('Show wbs editor', { service, param, addImmediate: !(service.JsonDefinition?.Parameters?.some(f => f.UserEditable) || service.JsonDefinition?.ComplexParameters?.length) });
					const wbsParams = {
						id: service.Oid,
						outparam: param.Name,
						hideServiceSelection: true,
						title: service.Name,
						addImmediate: !(service.JsonDefinition?.Parameters?.some(f => f.UserEditable) || service.JsonDefinition?.ComplexParameters?.length) && param?.DataType !== 'media',
						processCustom: (v) => {
							if (param?.SsmlTemplate?.ssml && !this.preventContextMenuCustomProcess) {
								[...v.childNodes].filter(f => f.nodeType === 3).map(f => f.remove())
								v.removeAttribute('isnew');
								v.classList.add('highlighted');
							
								const div = document.createElement('div');
								let html = param.SsmlTemplate.ssml.replace(/\[VALUE\]/gi, v.outerHTML);
								div.innerHTML = html;
								let servicesWithCurrentParam = [...div.querySelectorAll(`adthos\\:wbs[outparam="${param.Name}"]`)];
								servicesWithCurrentParam.map(f => {
									f.replaceWith(v);
								});

								const rootElem = div.querySelector('voice') || div;
								if (!param.SsmlTemplate.ssml.match(/\[VALUE\]/gi) && !servicesWithCurrentParam.length) {
									rootElem.prepend(v);
								}
								return rootElem.innerHTML;
							}
							return false;
						}
					};
					if (param?.SsmlTemplate?.ssml) {
						const div = document.createElement('div');
						div.innerHTML = param.SsmlTemplate.ssml;
						let templateServiceWithCurrentParam = div.querySelector(`adthos\\:wbs[outparam="${param.Name}]"`);
						if (templateServiceWithCurrentParam) {
							wbsParams.listOptions = json5.parse(templateServiceWithCurrentParam.getAttribute('listoptions') || '{}')
						}
					}
					dataButton.exec({ wbsParams });
				}
			},
			formatServicesForMenu(services) {
				return services.filter(f => f?.JsonDefinition?.Outputs?.filter(f => !f.Status)?.length).map(service => ({
					text: service.Name,
					template: 'service',
					imageUrl: service.ImageUrl,
					items: (service.JsonDefinition?.Outputs || []).filter(f => !f.Status).map(param => ({
						text: param.Caption || param.Name,
						template: 'output',
						param,
						service
					}))
				}));
			},
			async buildMenu() {
				const services = (await this.$Data.getExternalServices(0, 999)).Results;
				const categories = (await this.$Data.getWebServiceCategories(0, 999)).Results;

				const items = [];
				categories.map((category, catIdx) => {
					const groupItems = services.filter(s => s?.ServiceCategory?.Oid === category?.Oid);
					if (!groupItems.length) return;
					const catItem = {
						text: category.Name,
						template: 'category',
						imageUrl: category.ImageUrl,
						items: this.formatServicesForMenu(groupItems)
					}
					items.push(catItem);
				});

				const otherItems = services.filter(f => f.ServiceCategory?.Name === 'Other' || !categories.some(c => c.Oid === f?.ServiceCategory?.Oid)).filter(f => f?.JsonDefinition?.Outputs?.filter(f => !f.Status)?.length);
				if (otherItems.length) {
					const dynamicOther = categories.filter(f => f.Name === 'Other');
					let catItem = {
						text: this.$tCaption('Other'),
						template: 'category',
						imageUrl: dynamicOther?.ImageUrl || 'https://www.englishdom.com/dynamicus/blog-post/000/000/766/1589790773_content_700x455.jpg?1589790775344',
						items: otherItems.filter(f => f?.JsonDefinition?.Outputs?.filter(f => !f.Status)?.length).map(service => ({
							text: service.Name,
							template: 'service',
							imageUrl: service.ImageUrl,
							items: (service.JsonDefinition?.Outputs || []).filter(f => !f.Status).map(param => ({
								text: param.Caption || param.Name || param.Description,
								template: 'output',
								param,
								service
							}))
						}))
					}
					items.push(catItem);
				}

				this.webServicesMenuItems = items;

				if (__DEBUG__)
					console.debug('Build context menu', { services, categories });
			}
		}
	};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.insertion-editor--context-menu {
		.navigation-item {
			padding: 0px 2px 0px 2px !important;
			font-size: 14px;
			font-weight: 100;

			> .item {
				padding: 2px 8px 2px 2px;
				border-radius: 4px;
				background: rgb(250,250,250);
			}
			
			.image-holder {
				--size: 40px;
				width: var(--size);
				height: var(--size);
				min-width: var(--size);
				min-height: var(--size);
				border-radius: 4px;
				border: 2px solid rgb(241,241,241);
				background: #fff;
				text-align: center;

				.image {
					border-radius: 4px;
					width: 100%;
					height: 100%;
					background: var(--imageUrl);
					background-size: cover;
					background-position: center;
				}
			}
		}

		.category {
			.image-holder {
				--size: 40px;
				font-size: 16px;
			}
		}

		.dx-menu-item-expanded {
			.image {
				filter: brightness(1) grayscale(0);
			}
		}

		.service {
			font-size: 12px;
			.image-holder {
				--size: 30px;
			}
		}

		.output {
			font-size: 12px;
			font-weight: 100;
			padding: 4px 8px;
		}

		.dx-menu-items-container {
			padding: 2px 0px 0px !important;
			background: rgb(243,243,243);
			border-radius: 4px;
		}

		.dx-menu-item-expanded, .dx-menu-item-expanded.dx-state-focused, .dx-menu-item-expanded.dx-state-hover {
			background-color: transparent !important;
		}

		.dx-menu-item-expanded {
			> .navigation-item {
				> .item {
					background: $base-accent;
					color: $base-bg;
				}
			}
		}

		.limit-width {
			max-width: 150px;
		}

		.fixed-width {
			width: 150px;
		}

	}
</style>